import createReducer from './createReducer';
import {
  FETCH_TIDES,
  FETCH_TIDES_SUCCESS,
  FETCH_TIDES_FAILURE,
} from '../actions/tides';

const initialState = {
  loading: false,
  tides: {},
};

const handlers = {};

handlers[FETCH_TIDES] = state => ({
  ...state,
  loading: true,
});

handlers[FETCH_TIDES_SUCCESS] = (state, { tides }) => ({
  ...state,
  loading: false,
  tides,
});

handlers[FETCH_TIDES_FAILURE] = (state, { error }) => ({
  ...state,
  loading: false,
  error,
});

export default createReducer(handlers, initialState);



// WEBPACK FOOTER //
// ./src/reducers/tides.js